/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import Layout from "../../layout";
import Customer from "./features/customer";

const ManageCustomer = () => {
  return (
    <>
      <Layout>
        <section className="main_area">
          <Customer />
        </section>
      </Layout>
    </>
  );
};
export default ManageCustomer;
